import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { MainContent, Author } from '../sections/testimonial/SlideResponsive'
import { px2Rem } from '../../themes/Mixins'
import COLORS from '../../themes/Colors'

const Slide = ({ description, author }) => {
  return (
    <Wrapper>
      <MainContent
        type='base'
        text={`"${description}"`}
      />
      <Author
        type='base'
        text={author}
      />
    </Wrapper>
  )
}

// Defined styled component for Slide
const Wrapper = styled.div`
  font-size: ${px2Rem(40)};
  background-color: ${props => props.bgColor || COLORS.bgTestimonials};
  text-align: center;
`

Slide.propTypes = {
  description: PropTypes.string,
  author: PropTypes.string
}

Slide.defaultProps = {
  description: '',
  author: ''
}

export default Slide



// WEBPACK FOOTER //
// ./src/components/common/Slide.js